import { FullPageCenteredPageContent } from './LayoutComponents'

interface Props {
  message: string
}

export default function MaintenanceMessage({ message }: Props) {
  return (
    <FullPageCenteredPageContent>
      <p>{message}</p>
    </FullPageCenteredPageContent>
  )
}
